import { Input } from 'antd';
import 'antd/es/input/style/index.js';

export const InputGroup = Input.Group;
